import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders } from '../core/util/other';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { useAlert } from '../core';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';
import { FileData } from '../pages/job-manager/components/create-job-dialog';
import { commonShowAlert } from '../lib';

interface PostDbSchemaUploadProps {
    file: FileData;
    token: string;
    email: string;
    deleteDictionaries: boolean;
}

export const postDbSchemaUpload: MutationFunction<
    AxiosResponse<any>,
    PostDbSchemaUploadProps
> = async (props: PostDbSchemaUploadProps) => {
    const { file, token, email, deleteDictionaries } = props;
    const headers = getDefaultHeaders(token);
    const url = '/jobs/dbschema';

    const formData = new FormData();
    const response = await fetch(file.url);
    const blob = await response.blob();
    formData.append('file', blob, file.name);
    formData.append('delete', deleteDictionaries.toString());
    if (email) {
        formData.append('emailResultsTo', email);
    }
    return axiosInstance().post(url, formData, withHeaders(headers));
};

export const useDbSchemaUpload = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostDbSchemaUploadProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postDbSchemaUpload, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to create upload db schema job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
